const properties = {
	url: "",
    
	isIntegrated: true,

	authTokenKey: '111111',
	
	isELKEnabled: false,

	ELKURL: undefined
};

export const setProperties = config => {
	if ( config ) {
		for ( const key in config ) {
			properties[key] = config[key];
		}
	}
}

export default properties;